/**
 * Calculates the number of remaining days in the trial period.
 *
 * @param trialEndsAt - The trial end date as an ISO string (or null/undefined).
 * @returns The number of days remaining in the trial period.
 *
 * @remarks
 * - Returns 0 if `trialEndsAt` is null, undefined, or the trial has already expired.
 * - Uses `Math.ceil` to ensure partial days are counted as a full day
 *   (e.g., 1.2 days → 2 days remaining).
 */
export const getTrialDaysRemaining = (trialEndsAt?: string | null) => {
  if (!trialEndsAt) return 0;

  const now = new Date();
  const endDate = new Date(trialEndsAt);

  const diffTime = endDate.getTime() - now.getTime();

  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays > 0 ? diffDays : 0;
};
